const currencies = {
  USD: { trailingSymbol: false, code: 'USD', symbol: '$', listedPriceSymbol: 'US$', name: 'US Dollar' },
  CAD: { trailingSymbol: false, code: 'CAD', symbol: '$', listedPriceSymbol: 'CA$', name: 'Canadian Dollar' },
  EUR: { trailingSymbol: true, code: 'EUR', symbol: '€', listedPriceSymbol: '€', name: 'Euro' },
  GBP: { trailingSymbol: false, code: 'GBP', symbol: '£', listedPriceSymbol: '£', name: 'British Pound' },
  AUD: { trailingSymbol: false, code: 'AUD', symbol: '$', listedPriceSymbol: 'A$', name: 'Australian Dollar' },
  SEK: { trailingSymbol: false, code: 'SEK', symbol: 'Kr', listedPriceSymbol: 'SKr', name: 'Swedish Krona' },
  CZK: { trailingSymbol: false, code: 'CZK', symbol: 'Kč', listedPriceSymbol: 'Kč', name: 'Czech Koruna' },
  HUF: { trailingSymbol: false, code: 'HUF', symbol: 'Ft', listedPriceSymbol: 'Ft', name: 'Hungarian Forint' },
  PLN: { trailingSymbol: false, code: 'PLN', symbol: 'zł', listedPriceSymbol: 'zł', name: 'Polish Złoty' },
  NOK: { trailingSymbol: false, code: 'NOK', symbol: 'kr', listedPriceSymbol: 'Nkr', name: 'Norwegian Krone' },
  DKK: { trailingSymbol: false, code: 'DKK', symbol: 'kr', listedPriceSymbol: 'Dkr', name: 'Danish Krone' },
  CHF: { trailingSymbol: false, code: 'CHF', symbol: 'Fr.', listedPriceSymbol: 'SFr.', name: 'Swiss Franc' },
  INR: { trailingSymbol: false, code: 'INR', symbol: '₨', listedPriceSymbol: '₨', name: 'Indian Rupee' },
  RUB: { trailingSymbol: false, code: 'RUB', symbol: 'руб.', listedPriceSymbol: 'руб.', name: 'Russian Ruble' },
  NZD: { trailingSymbol: false, code: 'NZD', symbol: '$', listedPriceSymbol: 'NZ$', name: 'New Zealand Dollar' }
};

const supportedCurrencies = [
  currencies.USD,
  currencies.CAD,
  currencies.EUR,
  currencies.GBP,
  currencies.AUD,
  currencies.SEK,
  currencies.CZK,
  currencies.HUF,
  currencies.PLN,
  currencies.NOK,
  currencies.DKK,
  currencies.CHF,
  currencies.RUB,
  currencies.NZD
];

const supportedCurrencyCodes = () => {

  const result = [];
  supportedCurrencies.forEach((currency) => {

    result.push(currency.code);
  });
  return result;
};

module.exports.currencies = currencies;
module.exports.supportedCurrencies = supportedCurrencies;
module.exports.supportedCurrencyCodes = supportedCurrencyCodes;
